import React from "react";
import CompanyLogo from "../../assets/company.png";
import { withStyles } from "@material-ui/styles";
import theme from "../../Theme";
import { Skeleton } from '@material-ui/lab';

function CompanyImg({ style, imgSrc, classes, loading }) {

  if (loading) {
    return (
      <Skeleton variant="rect" className={classes.img_skeleton} style={{ margin: "auto", maxHeight: "70px" }}>
        <div
          src={CompanyLogo}
          className={classes.companyLogo}
          style={{
            width: "70px",
            height: "70px",
            marginLeft: "auto",
            marginRight: "auto",
            ...style,
            backgroundColor: theme.palette.primary.light,
          }}
          alt="company logo"
        />
      </Skeleton>
    )
  }

  if (imgSrc) {
    return (
      <img
        src={imgSrc}
        className={classes.companyLogo}
        style={style}
        alt="company logo"
      />
    );
  }

  return (
    <div
      src={CompanyLogo}
      className={classes.companyLogo}
      style={{
        width: "70px",
        height: "70px",
        marginLeft: "auto",
        marginRight: "auto",
        ...style,
        backgroundColor: theme.palette.primary.light,
      }}
      alt="company logo"
    />
  );
}

const styles = (theme) => ({
  companyLogo: {
    borderRadius: "9px",
    marginTop: "45px",
    maxWidth: "70px",
    overflow: "hidden",
    width: "70px",
    height: "70px",
    boxShadow:
      "0 2px 1px -1px rgba(0,0,0,.2), 0 1px 1px 0 rgba(0,0,0,.14), 0 1px 3px 0 rgba(0,0,0,.12)",
  },
  "@media (max-width: 700px)": {
    companyLogo: {
      width: "75px",
      marginTop: "10px",
      overflow: "hidden",
      borderRadius: "9px",
      boxShadow:
        "0 2px 1px -1px rgba(0,0,0,.2), 0 1px 1px 0 rgba(0,0,0,.14), 0 1px 3px 0 rgba(0,0,0,.12)",
    },
    img_skeleton: {
      marginTop: "23px !important"
    }
  },
});

export default withStyles(styles)(CompanyImg);
